import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

interface ErrorFallbackProps {
  error: unknown;
  onReset: () => void;
}

export function ErrorFallback({ error, onReset }: ErrorFallbackProps): ReactElement {
  const { t } = useTranslation();
  const message = error instanceof Error ? error.message : undefined;

  return (
    <>
      <p className="text-sm text-red-800">{t('error.generic.title')}</p>
      {message && (
        <details className="mt-2">
          <summary className="cursor-pointer text-xs text-red-500">
            {t('error.fetch.details')}
          </summary>
          <pre className="mt-1 whitespace-pre-wrap text-xs text-red-600">{message}</pre>
        </details>
      )}
      <button
        type="button"
        onClick={onReset}
        className={cn(
          'mt-2 inline-flex h-9 items-center justify-center rounded-md px-3',
          'text-sm font-medium text-emerald-800',
          'hover:bg-emerald-100'
        )}
      >
        {t('error.generic.retry.button')}
      </button>
    </>
  );
}
